import React from 'react';

const About = () => {
    return (
        <section className="about-section" id="about">
            <div className="section-header">
                <span className="section-tag">Câu Chuyện Di Sản</span>
                <h2>Hơn 40 Năm Giữ Trọn <span>Hồn Cà Phê Phin</span></h2>
                <div className="header-divider">
                    <i className="fas fa-coffee"></i>
                </div>
            </div>

            <div className="about-grid">
                <div className="about-image-wrapper">
                    <img
                        src="/images/cafe9/cafe912.JPG"
                        alt="Không gian và cà phê phin tại Café 9 Phước Hải"
                        className="about-main-image"
                    />
                    <div className="about-floating-card">
                        <div className="year">1983</div>
                        <div className="text">Điểm cà phê rang xay pha phin đầu tiên tại Phước Hải</div>
                    </div>
                </div>

                <div className="about-content-wrapper">
                    <span className="tag-line">Nghệ Thuật Cà Phê Phin Đích Thực</span>
                    <h3>Tìm Lại Sự Bình Yên Bên Từng Giọt Cà Phê Rơi</h3>

                    <p className="about-quote">
                        "Cà phê phin có vị cà phê đích thực. Ngồi trước phin cà phê thong thả ngắm nhìn từng giọt rơi để lãng quên mọi ưu tư, tìm đến thanh thản cho tâm hồn."
                    </p>

                    <p className="about-text">
                        Café 9 chính thức phục vụ từ năm 1983, tự hào là một trong những điểm tiên phong tại thị trấn Phước Hải gìn giữ trọn vẹn văn hoá pha cà phê bằng nguyên hạt rang xay nguyên chất bằng phin nhôm truyền thống. Trải qua hơn 4 thập kỷ, Café 9 vẫn luôn là chốn dừng chân thân thương của người dân địa phương và du khách gần xa yêu thích hương vị mộc mạc, đậm đà.
                    </p>

                    <div className="about-pillars">
                        <div className="pillar-item">
                            <div className="pillar-icon">
                                <i className="fas fa-fire-flame-curved"></i>
                            </div>
                            <div className="pillar-info">
                                <h4>Rang Xay Thủ Công</h4>
                                <p>Hạt cà phê tuyển chọn kỹ lưỡng, giữ trọn hương thơm tự nhiên.</p>
                            </div>
                        </div>

                        <div className="pillar-item">
                            <div className="pillar-icon">
                                <i className="fas fa-mug-saucer"></i>
                            </div>
                            <div className="pillar-info">
                                <h4>Bí Quyết Pha Phin</h4>
                                <p>Ủ nhiệt chuẩn xác cho từng giọt cà phê sánh đặc, hậu vị sâu lắng.</p>
                            </div>
                        </div>

                        <div className="pillar-item">
                            <div className="pillar-icon">
                                <i className="fas fa-water"></i>
                            </div>
                            <div className="pillar-info">
                                <h4>Không Gian Thư Thái</h4>
                                <p>Gió biển trong lành, mộc mạc đậm chất đời sống làng chài Phước Hải.</p>
                            </div>
                        </div>

                        <div className="pillar-item">
                            <div className="pillar-icon">
                                <i className="fas fa-heart"></i>
                            </div>
                            <div className="pillar-info">
                                <h4>Giá Cả Chân Phương</h4>
                                <p>Mức giá thân thiện, bình dân phục vụ chu đáo mọi đối tượng khách hàng.</p>
                            </div>
                        </div>
                    </div>

                    <a href="#menu" className="btn btn-outline">
                        <i className="fas fa-utensils"></i>
                        <span>Khám Phá Menu Quán</span>
                    </a>
                </div>
            </div>
        </section>
    );
};

export default About;